import { Claims } from "./claims"

export class RoleClaims extends Claims {

    constructor() {
        super('role')
    }

    public readonly Administrator: string = "admin"
}